import { createSelector } from 'reselect';

const selectNewHireData = (state) => state.newhire;

export const selectDepartments = createSelector(
  [selectNewHireData],
  (newhire) => {
    if (newhire.data !== null) {
      return newhire.data.departments;
    }

    return null;
  }
);

export const selectLocalDistros = createSelector(
  [selectNewHireData],
  (newHire) => {
    if (newHire.data !== null) {
      return newHire.data.localDistros;
    }
  }
);

export const selectNewHireFirstName = createSelector(
  [selectNewHireData],
  (newHire) => newHire.firstName
);

export const selectNewHireLastName = createSelector(
  [selectNewHireData],
  (newHire) => newHire.lastName
);

export const selectNewHireDepartment = createSelector(
  [selectNewHireData],
  (newHire) => newHire.currDepartment
);

export const selectNewHirePosition = createSelector(
  [selectNewHireData],
  (newHire) => newHire.currPosition
);

export const selectNewHireDoh = createSelector(
  [selectNewHireData],
  (newHire) => newHire.hireDate
);

export const selectNewHireLocalDistros = createSelector(
  [selectNewHireData],
  (newHire) => (newHire.localDistros !== null ? newHire.localDistros : [])
);

export const selectAzureGroups = createSelector(
  [selectNewHireData],
  (newHire) => (newHire.azureGroups !== null ? newHire.azureGroups : [])
);

export const selectGoogleGroups = createSelector(
  [selectNewHireData],
  (newHire) => (newHire.googleGroups !== null ? newHire.googleGroups : [])
);

export const selectNoc = createSelector(
  [selectNewHireData],
  (newHire) => newHire.noc
);

export const selectNavitaire = createSelector(
  [selectNewHireData],
  (newHire) => newHire.navitaire
);

export const selectNewHireLocation = createSelector(
  [selectNewHireData],
  (newHire) => newHire.location
);

export const selectNewHireUber = createSelector(
  [selectNewHireData],
  (newHire) => newHire.uber
);

export const selectNewHireLyft = createSelector(
  [selectNewHireData],
  (newHire) => newHire.lyft
);

export const selectNewHireRef = createSelector(
  [selectNewHireData],
  (newHire) => newHire.data
);

export const selectNewHireDepartmentTailMapping = createSelector(
  [selectNewHireData],
  (newHire) => newHire.departmentTailNumberMapping
);

export const selectNewHireInvoiceGroupMapping = createSelector(
  [selectNewHireData],
  (newHire) => newHire.invoiceGroupMapping
);

export const selectNewHireExpensePolicyMapping = createSelector(
  [selectNewHireData],
  (newHire) => newHire.expensePolicyGroupMapping
);

// export const selectPositions = createSelector(
//   [selectNewHireData, (state, department) => department],
//   (newhire, department) => {
//     if (newhire.data !== null && department) {
//       newhire.data.departments.forEach((dep) => {
//         if (department === dep) {
//           return dep.positions.map((position) => position.title);
//         }
//       });
//     }

//     return null;
//   }
// );
